import * as pdfjs from 'pdfjs-dist';

// Configurar el worker de PDF.js usando CDN
// Esto permite que los PDFs se procesen en un hilo separado sin bloquear la UI
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export { pdfjs };
